/**
 * Generated runtime TestId mirror for frontend/src/features/service-accounts/components/RemoveRoleDialog.tsx.
 * DO NOT EDIT MANUALLY — re-run scripts/generate-testid-constants.py.
 *
 * Runtime mirror — same values as frontend/e2e/helpers/testids/. Help maps
 * under frontend/src/locales/ import this module to express computed-property
 * keys (e.g. `[XxxTestIds.fooBar]: '...'`).
 */

export const RemoveRoleDialogTestIds = {
  removeRoleDialogBody: "remove-role-dialog-body",
  removeRoleDialogTitle: "remove-role-dialog-title"
} as const;
